import React, { Component } from 'react';
import { Modal, Form, Button, Icon } from 'semantic-ui-react';
import MutationInfo from '../../../common/components/MutationInfo';
import SaveButtonWithTooltip from '../../../common/components/SaveButtonWithTooltip';
import {
  lengthInRange,
  notEmpty,
  emptyOrValidDate,
  intInRange,
  validUrl,
  report,
} from '../../../../common/utils/inputValidator.js';
import { updateInPath } from '../../../../common/utils';
import { clone } from 'ramda';
import CompetitionTab from './Tab';

const BLANK = {
  code: '',
  date: '',
  competitionRulesURL: 'https://robotex.international/terms-and-conditions/',
  teamMemberLimit: 0,
  robotRequired: true,
  published: false,
  event: { id: '', title : '', type: ''},
  difficulty: 'beginner',
  i18n_description: {},
  i18n_title: {},
  price: [],
  coupons: [],
  competitionType: 'TIME',
  attemptsLimit: 1,
  attemptMaxLengthInSeconds: 0,
  concurrentCompetitors: 2,
  rrtCompetitorsInGroupMin: 0,
  rrtCompetitorsInGroupMax: 0,
  rrtCompetitorsInGroupAdvancing: 0,
  rrtConcurrentGroups: 0,
  rrtConcurrentGroupGames: 0
};

export default class MutationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: clone(this.props.data) || clone(BLANK)
    };
  }

  saveEnabled = (data) => {
    const checks = [
      notEmpty(data.event, 'Event'),
      // TODO title check!
      lengthInRange(data.code, [2, 5], 'Code'),
      emptyOrValidDate(data.beginDate, 'Begin date'),
      intInRange(data.teamMemberLimit, [0, 99], 'Team member limit'),
      validUrl(data.competitionRulesURL, 'Competition Rules URL')
    ];
    return report(checks);
  };

  handleUpdate = (data) => {
    this.setState(s => updateInPath(s, 'save', this.saveEnabled(data)));
  }

  handleSave = () => {
    this.props.onSave(clone(this.state.data));
  };

  handleChange = (e, {name, value}) => {
    this.setState(s => updateInPath(s, 'data.' + name, value));
  };

  handleToggle = (e, {name, checked}) => {
    this.setState(s => updateInPath(s, 'data.' + name, checked));
  };

  handleEventChange = (filter, event) => {
    this.setState(s => updateInPath(s, 'data.event.title', event.text));
    this.setState(s => updateInPath(s, 'data.event.id', event.value));
    this.setState(s => updateInPath(s, 'data.event.type', event.type));
  };
  
  render() {
    const { open, onClose } = this.props,
          { data } = this.state,
          eventType = data.event ? data.event.type : '',
          save = this.saveEnabled(data);

    return (
      <Modal open={open}>
        <Modal.Header>
          {data.competitionId ? 'Edit ' + eventType : 'Add ' + eventType}
          &nbsp;
          {eventType === 'COMPETITION' && <Icon name='trophy' />}
          {eventType === 'WORKSHOP' && <Icon name='wrench' />}
        </Modal.Header>
        <Modal.Content>
          <Form>
            <CompetitionTab
              data={data}
              onChange={this.handleChange}
              onToggle={this.handleToggle}
              onEventChange={this.handleEventChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <MutationInfo
            who={data.createdBy}
            when={data.createdAt}/>
          <Button negative content='Cancel' onClick={onClose}/>
          <SaveButtonWithTooltip
            enabled={save.enabled}
            tooltip={save.errors}
            onSave={this.handleSave}/>
        </Modal.Actions>
      </Modal>
    );
  };
};



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/index.js